import { Badge, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'
import ProductStatusBadge from 'domains/product/atoms/product-status-badge/'
import ProductGenderBadge from 'domains/product/atoms/gender-badge/product-gender-badge'
import TimeUtil from 'utils/time-util'
import InStockBadge from 'domains/product/atoms/in-stock-badge'

const propTypes = {
  product     : PropTypes.object,
  handleClick : PropTypes.func
}

const defaultProps = {
  product     : {},
  handleClick : () => {}
}

const ProductTableRow = ({
  product,
  handleClick
}) => {
  let diffDays = 0

  if (product.live_date){
    const today    = new Date()
    const liveDate = new Date(product.live_date)
    const diffTime = Math.abs(today - liveDate)
    diffDays       = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  }

  const price     = PriceUtil.format(product.selling_price)
  const live_date = TimeUtil.format(product.live_date)

  return (
    <tr>
      <td>
        <img
          style={{ width: '5rem' }}
          src={ product.main_image }
          alt={ product.sku }
        />
      </td>
      <td>{ product.name }</td>
      <td>
        <div>{ product.sku }</div>
        <div>{ product.details.brand }</div>
        <div>{ product.details.colour }</div>
        <div>{ product.details.category }</div>
        <div>{ product.details.condition }</div>
      </td>
      <td>
        <ProductGenderBadge gender={ product.gender } />
      </td>
      <td>{ price }</td>
      <td>
        <Badge color='primary'>{ product.productable_type }</Badge>
      </td>
      <td>{ live_date }</td>
      <td>{ diffDays }</td>
      <td>
        <ProductStatusBadge product_status={ product.status } />
      </td>
      <td>
        <InStockBadge is_in_stock={ product.is_in_stock } />
      </td>
      <td className="d-flex flex-column bd-highlight mb-3">
        <Button
          size='sm'
          color='info'
          className= 'align-self-center'
          onClick={ () => handleClick(product.id) }
        >
          { 'Detail' }
        </Button>
      </td>
    </tr>
  )
}

ProductTableRow.propTypes    = propTypes
ProductTableRow.defaultProps = defaultProps

export default ProductTableRow